// https://github.com/microsoft/fluentui/issues/6476
export function fixExitWhenClickOnDialog() { }
